<template>
  <div class="m-0 dbozone-font bg-superbros" :class="`${lang}-font`">
    <div class="container d-flex flex-column justify-content-center">
      <div class="d-flex flex-column nav-superbros">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -superbros`">{{ $t('4_5_base.paytable.symtable_title') }}</h5>
        </section>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-4">
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/superBros/symbol_0.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex align-items-center ml-2">
          <span class="font-weight-bold text-sub mt-3" :class="`-${lang}`">{{$t('4_5_base.paytable.symtable_wild1')}}
            <br>{{$t('4_5_base.paytable.symtable_wild2')}}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/superBros/symbol_1.png`)" alt="">
        </div>
        <div class="col-3 align-items-center p-0 d-flex ml-2">
          <span class="font-weight-bold text-sub mt-3" :class="`-${lang}`">{{$t('4_5_base.paytable.symtable_wild1')}}
            <br>{{$t('4_5_base.paytable.symtable_scatter')}}
          </span>
        </div>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0  align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/superBros/symbol_2.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class="text-sub" :class="`-${lang}`">{{'5 - ' + paytable[2][3]}}
            <br>{{'4 - ' + paytable[2][2]}}
            <br>{{'3 - ' + paytable[2][1]}}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/superBros/symbol_3.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class="text-sub" :class="`-${lang}`">{{'5 - ' + paytable[3][3]}}
            <br>{{'4 - ' + paytable[3][2]}}
            <br>{{'3 - ' + paytable[3][1]}}
          </span>
        </div>
      </div>
      <div class="col-12 mt-3 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/superBros/symbol_4.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class="text-sub" :class="`-${lang}`">{{'5 - ' + paytable[4][3]}}
            <br>{{'4 - ' + paytable[4][2]}}
            <br>{{'3 - ' + paytable[4][1]}}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/superBros/symbol_5.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class="text-sub" :class="`-${lang}`">{{'5 - ' + paytable[5][3]}}
            <br>{{'4 - ' + paytable[5][2]}}
            <br>{{'3 - ' + paytable[5][1]}}
          </span>
        </div>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/superBros/symbol_6.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class="text-sub" :class="`-${lang}`">{{'5 - ' + paytable[6][3]}}
            <br>{{'4 - ' + paytable[6][2]}}
            <br>{{'3 - ' + paytable[6][1]}}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/superBros/symbol_7.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class="text-sub" :class="`-${lang}`">{{'5 - ' + paytable[7][3]}}
            <br>{{'4 - ' + paytable[7][2]}}
            <br>{{'3 - ' + paytable[7][1]}}
          </span>
        </div>
      </div>
      <div class="col-12 mt-3 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/superBros/symbol_8.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class="text-sub" :class="`-${lang}`">{{'5 - ' + paytable[8][3]}}
            <br>{{'4 - ' + paytable[8][2]}}
            <br>{{'3 - ' + paytable[8][1]}}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/superBros/symbol_9.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class="text-sub" :class="`-${lang}`">{{'5 - ' + paytable[9][3]}}
            <br>{{'4 - ' + paytable[9][2]}}
            <br>{{'3 - ' + paytable[9][1]}}
          </span>
        </div>
      </div>


      <div class="d-flex flex-column nav-superbros mt-4">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-superbros`">
            {{ $t("4_5_base.freespin") }}
          </h5>
        </section>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("4_5_base.text-freespin1")
        }}</span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("4_5_base.text-freespin2")
        }}</span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("4_5_base.text-freespin3")
        }}</span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("4_5_base.text-freespin4")
        }}</span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("4_5_base.text-freespin5")
        }}</span>
      </div>

      <div class="d-flex flex-column nav-superbros mt-4">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -superbros`">{{ $t('featurebuy.title') }}</h5>
        </section>
      </div>
       <div class="d-flex p-2 mt-1 mb-2 justify-content-center">
        <img class="mt-3 icon-startbutton" :src="require(`../../assets/paytable/superbros/feature_buy_${imgLang}.png`)"
          alt="">
      </div>
       <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('featurebuy.text1') }}</span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('featurebuy.text2') }}</span>
      </div>

      <div class="d-flex flex-column nav-superbros mt-4">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -superbros`">{{ $t('4_5_base.way.name') }}</h5>
        </section>
      </div>
      <div class="d-flex p-2 mt-3">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('4_5_base.way.text1') }}</span>
      </div>
      <div class="justify-content-center d-flex flex-row">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/pay/4_5_combo.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 mb-1 mt-3">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('4_5_base.way.text2') }}</span>
      </div>
      <div class="d-flex p-2 mb-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('4_5_base.way.text3') }}</span>
      </div>
      <div class="d-flex p-2 mb-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('4_5_base.way.text4') }}</span>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'paytable-superbros',
  props: {
    data: Object,
    lang: String,
    imgLang: String
  },
  data() {
    return {
      paytable: this.data.config.payTable
    }
  }
}
</script>

<style>

.bg-superbros {
  background: #07379D;
}

.nav-superbros {
  background-color: #F5CA01;
  border-radius: 5px 5px 5px 5px;
}

.text-title.-superbros {
  color: #000;
}

@media screen and (max-width: 768px) {
  .header > div {
    flex-grow: 0;
    width: 33.33%;
  }
}

</style>